import { render, staticRenderFns } from "./ot-standard-header-archetype.vue?vue&type=template&id=7a956058&scoped=true&"
import script from "./ot-standard-header-archetype.vue?vue&type=script&lang=ts&"
export * from "./ot-standard-header-archetype.vue?vue&type=script&lang=ts&"
import style0 from "./ot-standard-header-archetype.vue?vue&type=style&index=0&id=7a956058&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a956058",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VMenu})
